//------------------------------------------------------ externos
import { useNavigate } from "react-router-dom";
//------------------------------------------------------ elementos
import MovimientoEmpresaAccess from "../components/access/accessButtons/MovimientoEmpresaAccess";
import MovimientoStockAccess from "../components/access/accessButtons/MovimientoStockAccess";
import Button from "../components/buttons/Button";
import CardLogo from "../components/cards/CardLogo";
import EmpresasAccess from "../components/access/EmpresasAccess";

const Deposits = () => {
  console.log("[Render] Seccion Depósitos");
  const navegar = useNavigate();

  return (
    <section className="section">
      <div className="sections-options-group">
        <div className="section-options-row-right">
          <div className="sections-options-row">
            {/* «Herramientas asignadas» abría el modal de la colección vieja
                `asignaciones`, del modelo heredado de CantApp: un listado
                paralelo al sector de herramientas, con otros datos. Nico
                (por Igna, 03/10): está «duplicado», que lleve a nuestro
                sector. El botón se queda donde la gente lo busca; lo que
                cambia es adónde va. */}
            <CardLogo
              icono="lista"
              title="Herramientas asignadas"
              route="/taller/herramientas"
            />
          </div>
          <div className="sections-options-row">
            {/* El padrón de proveedores, con el nombre que tiene en el menú
                del Pañol desde el 20/10. Es la misma lista. */}
            <EmpresasAccess col={"proveedores"} titulo="Talleres y servicios" />
          </div>
          <div className="sections-options">
            <MovimientoStockAccess typeForm={"movimiento"} />
            <MovimientoStockAccess
              typeForm={"movimiento"}
              type={"stockDepositos"}
              title={"MOVIMIENTO E/ DEPOSITOS"}
            />
            {/* «Asignar herramienta» abría `FormAsignacion`, que escribe en la
                misma colección vieja. Nadie lo usó desde el hub: las 32 filas
                de `asignaciones` son de Firestore (mayo-julio, 20 «migrado por
                script» y 6 «prueba»). Asignar hoy es darle la herramienta a
                la caja de alguien en el sector, así que el botón lleva ahí. */}
            <Button
              text="ASIGNAR HERRAMIENTA"
              icono="herramienta"
              plus={true}
              onClick={() => navegar("/taller/herramientas")}
            />
          </div>
          <div className="sections-options">
            <MovimientoStockAccess typeForm={"articulo"} />
            <MovimientoEmpresaAccess />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Deposits;
